import React, { useState } from "react";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import SimpleButton from "../../Components/layouts/simple_button";
import Footer from "../../Components/Footer/footer";
import { Formik, Form } from "formik";
import CustomInput from "../../CustomComponent/custom_input";
import CustomSelect from "../../CustomComponent/custom_select";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { applicationFormInfo } from "../../SchemaInfo/info";
import LoadingPage from "../../Components/layouts/loading";
import CustomTextArea from "../../CustomComponent/custom_textarea";
import { ApplicationSchema } from "../../Schemas/carrer/applicationForm";
import { FcSms } from "react-icons/fc";
import { BsPostcardHeartFill } from "react-icons/bs";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcStackOfPhotos } from "react-icons/fc";

const ApplicationForm = () => {
  let userData = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handelSubmit = (values, actions) => {
    // values = {
    //   ...values,
    //   genratedBy: userData?.UserId,
    // };
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };

    setLoading(true);
    performRequest("POST", "/career/job-application/create", formData, headers)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Application Sumbited successfully!");
          navigate(`/`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="text-center">
              <h1>
                <FcStackOfPhotos className="fs-1  me-1" /> Job Application Form
              </h1>
              <hr></hr>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <p>
                  Our team will carefully review your profile and get in touch
                  if it aligns with any current or upcoming roles. You’re
                  welcome to apply for both full-time jobs and internships
                  across departments. We appreciate your interest in working
                  with Kryzen Biotech—stay tuned, and we’ll connect soon if
                  there's a match.
                </p>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <Formik
                  initialValues={applicationFormInfo}
                  validationSchema={ApplicationSchema}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            First Name
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="Fname" type="text" />
                            {props.touched.Fname && props.errors.Fname && (
                              <p className="text-danger">
                                {props.errors.Fname}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Last Name
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="Lname" type="text" />
                            {props.touched.Lname && props.errors.Lname && (
                              <p className="text-danger">
                                {props.errors.Lname}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Email
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="email" type="text" />
                            {props.touched.email && props.errors.email && (
                              <p className="text-danger">
                                {props.errors.email}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Phone No
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="phoneNo" type="text" />
                            {props.touched.phoneNo && props.errors.phoneNo && (
                              <p className="text-danger">
                                {props.errors.phoneNo}
                              </p>
                            )}
                          </div>
                        </div>
                        {/* <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Applied Position
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="position" type="text" />
                            {props.touched.position &&
                              props.errors.position && (
                                <p className="text-danger">
                                  {props.errors.position}
                                </p>
                              )}
                          </div>
                        </div> */}
                        {/* <div className="mb-3 row">
                          <label className="w-25 form-label required col-3 ">
                            Departments
                          </label>
                          <div className="w-100 col">
                            <CustomSelect type="text" name="departments">
                              <option value="">Select</option>
                              <option value="Accounting">Accounting</option>
                              <option value="Human Resource">
                                Human Resource
                              </option>
                              <option value="Business Devlopment">
                                Business Devlopment / Sales
                              </option>
                              <option value="Marketing">Marketing</option>
                              <option value="Management">Management</option>
                              <option value="Purchase">Purchase</option>
                              <option value="Agronomist">Agronomist</option>
                            </CustomSelect>
                            {props.touched.jobType && props.errors.jobType && (
                              <p className="text-danger">
                                {props.errors.jobType}
                              </p>
                            )}
                          </div>
                        </div> */}
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3 ">
                            Job Type
                          </label>
                          <div className="w-100 col">
                            <CustomSelect type="text" name="jobType">
                              <option value="">Select</option>
                              <option value="Internship">Internship</option>
                              <option value="job">Job</option>
                            </CustomSelect>
                            {props.touched.jobType && props.errors.jobType && (
                              <p className="text-danger">
                                {props.errors.jobType}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3 ">
                            Employee Type
                          </label>
                          <div className="w-100 col">
                            <CustomSelect type="text" name="Etype">
                              <option value="">Select</option>
                              <option value="Fresher">Fresher</option>
                              <option value="Experience">Experience</option>
                            </CustomSelect>
                            {props.touched.Etype && props.errors.Etype && (
                              <p className="text-danger">
                                {props.errors.Etype}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            Departments
                          </label>
                          <div className="w-100 col">
                            <CustomSelect type="text" name="departments">
                              <option value="">Select</option>
                              <option value="Business Development Department">
                                Business Development Department (Sales) 
                              </option>
                              <option value="Operations Executive Department">
                                Operations Executive Department (Purchase) 
                              </option>
                              <option value="Social Media Marketing Department">
                                Social Media Marketing Department (Video Editing, Graphic
                                Design)
                              </option>
                              <option value="Human Resources">
                                Human Resources Department
                              </option>
                              <option value="Accounting Department">Accounting Department</option>
                              <option value="Management Department">Management Department</option>
                              <option value="Agronomist Department">Agronomist Department</option>
                            </CustomSelect>
                            {props.touched.departments &&
                              props.errors.departments && (
                                <p className="text-danger">
                                  {props.errors.departments}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Skills
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="skills" type="text" placeholder="e.g. communication, graphic design, video editing" />
                            {props.touched.skills && props.errors.skills && (
                              <p className="text-danger">
                                {props.errors.skills}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Upload CV
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="uploadcv"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "uploadcv",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.uploadcv &&
                              props.errors.uploadcv && (
                                <p className="text-danger">
                                  {props.errors.uploadcv}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Submit Application" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ApplicationForm;
